import { observer } from 'mobx-react'
import React from 'react'
import { gState } from '../../../utils/controllers/GlobalStateController'
import { getComp } from '../../../utils/utils/DI'
import DealerCard from '../../../views/RequestsManagement/components/RequestDetails/AssignToDealerView/utils/DealerCard'
import CustomAccordion from './utils/CustomAccordion'

function AssignedDealer({ request, defaultOpenState, onEdit }) {
  const intl = gState['intl']

  return (
    <CustomAccordion
      defaultOpenState={defaultOpenState}
      summary={intl.formatMessage({ id: 'Назначенный дилер' })}
      onEdit={onEdit}
    >
      <DealerCard
        dealer={
          getComp('DealersStore').getDealer(request.dealer) ||
          getComp('DealersStore').getDealer(request.assignedDealerId) ||
          getComp('DealersStore').getDealer(request.dealerId)
        }
        selected
        onlyShow={true}
      />
    </CustomAccordion>
  )
}

export default observer(AssignedDealer)
